import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useUserManagement from '@/composables/useUserManagement'
  import UsersApi from '@/services/api/UsersApi'
  import { UserModule } from '@/store/modules/user'
  import pluralize from 'pluralize'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InviteUserModal',
  emits: ['close'],
  setup(__props, { emit }) {

  

  const { checkmark } = useIcons()
  const { translateString } = useI18n()
  const { validator, setInputItems, formState, onInputChange, inputItems, hasValidationError, filteredFormState } =
    useUserManagement()
  setInputItems(['email1', 'email2', 'email3'], 'email')

  const sendingInvite = ref(false)
  const sendInvite = () => {
    validator.value.$touch()
    if (!validator.value.$invalid) {
      eventBus.$emit('turn-on-loader')
      sendingInvite.value = true
      UsersApi.inviteUser({
        companyId: UserModule.currentCompany!.id,
        emails: filteredFormState.value,
      })
        .then(async (resp) => {
          const users = pluralize(translateString('homepage.inviteUser.user'), filteredFormState.value.length, true)
          UserModule.appendUserMembers({ users: resp.users, action: 'invite-user' })
          eventBus.$toasted.success(translateString('homepage.inviteUser.successMessage', { users }))
          await UserModule.getCompanyActivityLog()
          eventBus.$emit('turn-off-loader')
        })
        .finally(() => {
          emit('close')
          sendingInvite.value = false
        })
    }
  }

return { __sfc: true,emit, checkmark, translateString, validator, setInputItems, formState, onInputChange, inputItems, hasValidationError, filteredFormState, sendingInvite, sendInvite, ref, KetchUpButton, LoadingSpinner, useIcons, SVGRenderer, useUserManagement, UsersApi, UserModule, pluralize, eventBus, useI18n }
}

})